import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ConsultarPedidosEncomenda } from "../funcionalidades/bancoGet";
import ComponenteNotaVendedora from '../subComponents/ComponenteNotaVendedora'
import ComponenteNotaFornecedor from '../subComponents/ComponenteNotaFornecedor'
import ComponenteNotaExpedicao from '../subComponents/ComponenteNotaExpedicao'
import GlobalVar from "../subComponents/GlobalVar";
import TopMenu from '../TopMenu'



const ConsultarPedidosVendedoras = ({ativaResp, showStyle}) => {

    // const navigate = useNavigate();
    

    useEffect(()=>{
        if(!showStyle) return;
        import('../../assets/css/auxiliar/scrolbar.css')
        import('../../assets/css/estiloPaginas/consultarPedidosVendedoras.css')
        import('../../assets/css/estiloPaginas/consultarIPedidosVendedoras.css')
    },[])



    const [notaResult, setNotaResult] = useState([])   
    const [filtrarPedidos, setFiltrarPedidos]  = useState('Novos') 
    const [atualizaConsulta, setatualizaConsulta] = useState(false)

    const [usuario, setUsuario] = useState(GlobalVar.getSessionStorage('usuario'));
     const cargo = () => usuario?.usu_tipo == 4 ? 'EXPEDICAO' : usuario.fornInfo?.for_cod ? 'FORNECEDOR' : 'VENDEDORA'


    useEffect(()=>{
        if(!usuario) return;
            setNotaResult([])
            ConsultarPedidosEncomenda({codigovend: usuario.vendedora?.codigovend, fornecedor: usuario.fornInfo?.for_cod,
            expedicao: usuario?.usu_tipo == 4 ? usuario?.usu_loja : false})
                .then((resp)=>{
                    if(resp.Error){
                        
                    }else{
                        setNotaResult(resp)
                    }
                })
        
    },[usuario, atualizaConsulta])

    const filtrarPedido = (item)=>{
        if(usuario?.usu_tipo == 4){
            if(filtrarPedidos == 'Novos'){
                return item.status !== 'RECEBIDO PELA BABITA' && item.status !== 'PEDIDO ENTREGUE PELA BABITA' && item.documento_origem
            }else{
                return item.status == 'RECEBIDO PELA BABITA' || item.status == 'PEDIDO ENTREGUE PELA BABITA' && item.documento_origem
            }
        }else if (usuario.vendedora?.codigovend){
            return true
        }else{
            if(filtrarPedidos == 'Novos'){
                return item.rom_doc == 'PENDENTE' && item.status !== 'RECEBIDO PELA BABITA' && item.status !== 'PEDIDO ENTREGUE PELA BABITA'
            }else{
                return item.rom_doc != 'PENDENTE' && item.status !== 'RECEBIDO PELA BABITA' && item.status !== 'PEDIDO ENTREGUE PELA BABITA'
            }
        }
    }

    if (!usuario) {
        return <div>Carregando...</div>;
      }
    return <>
    <TopMenu ativaResp={ativaResp} showStyle={true}>
    </TopMenu>
            {/* <div className="container mx-auto"> */}
            <div className="containerPrincipal consultarPedidosVendedoras" style={{minHeight: "90vh", /*maxHeight: windowHeight*0.80,*/ display: 'flex',
    flexDirection: 'column', /*overflowY: "hidden"*/}}>


                
                {usuario?.usu_tipo == 4 ? <div className="selectFiltroNotas">
                    <div className={`novasNotas ${filtrarPedidos == 'Novos' ? 'selecionado' : ''}`}
                    onClick={()=>setFiltrarPedidos('Novos')}>Pedidos A Receber</div>
                    <div className={`romaneioGerado ${filtrarPedidos == 'Romaneio' ? 'selecionado' : ''}`}
                    onClick={()=>setFiltrarPedidos('Romaneio')}>Pedidos Confirmados</div>
                </div> : 
                usuario.fornInfo?.for_cod ? 
                    <div className="selectFiltroNotas">
                        <div className={`novasNotas ${filtrarPedidos == 'Novos' ? 'selecionado' : ''}`}
                        onClick={()=>setFiltrarPedidos('Novos')}>Pedidos Novos</div>
                        <div className={`romaneioGerado ${filtrarPedidos == 'Romaneio' ? 'selecionado' : ''}`}
                        onClick={()=>setFiltrarPedidos('Romaneio')}>Romaneio Gerado</div>
                    </div> : 
                <></>}

                <div className={`dataConsulta ${ativaResp ? '' : ''}`}>
                    
                    {notaResult && notaResult.length > 0 ? notaResult.filter(item => filtrarPedido(item)).map((val,index) => 
                    cargo() == 'VENDEDORA' ? <ComponenteNotaVendedora item={val} index={index} key={val.documento+"Vend"+"CABE"}
                    ativaResp={ativaResp} usuarioTipo={'vendedora'}/>
                    : cargo() == 'FORNECEDOR' ? <ComponenteNotaFornecedor item={val} index={index} key={val.documento+"FOR"+"CABE"}
                    ativaResp={ativaResp} usuarioTipo={'fornecedor' } romaneioGerado={val.rom_doc != 'PENDENTE'}/> :
                    <ComponenteNotaExpedicao item={val} index={index} key={val.documento+"EXP"+"CABE"}
                    ativaResp={ativaResp} usuarioTipo={'fornecedor' } atualizaConsulta={atualizaConsulta}
                    setatualizaConsulta={setatualizaConsulta} usuario={usuario}/>
                    ) : <></>}
                </div>
        </div>
           </>
}

export default ConsultarPedidosVendedoras;
